import { FaLightbulb, FaFlask, FaDraftingCompass, FaTools, FaChartLine, FaHeadset } from 'react-icons/fa';
import images from './images';

const process = [
    {
        id: 1,
        image: images.step1,
        icon: <FaLightbulb />, // Lightbulb icon for Ideation
        title: 'Ideation',
        content: 'We collaborate with clients to understand their vision and create tailored strategies.',
    },
    {
        id: 2,
        image: images.step2,
        icon: <FaFlask />, // Flask icon for Research
        title: 'Research',
        content: 'We explore the latest AI and IT technologies to craft cutting-edge solutions.',
    },
    {
        id: 3,
        image: images.step3,
        icon: <FaDraftingCompass />, // Compass icon for Prototyping
        title: 'Prototyping',
        content: 'We develop and test prototypes to ensure the solution aligns with your business goals.',
    },
    {
        id: 4,
        image: images.step4,
        icon: <FaTools />, // Tools icon for Execution
        title: 'Execution',
        content: 'We integrate our solutions seamlessly into your operations for maximum efficiency.',
    },
    {
        id: 5,
        image: images.step5,
        icon: <FaChartLine />, // Chart icon for Optimization
        title: 'Optimization',
        content: 'We fine-tune and scale solutions to ensure they evolve with your business needs.',
    },
    {
        id: 6,
        image: images.step6,
        icon: <FaHeadset />, // Headset icon for Extended Care
        title: 'Extended Care',
        content: 'We provide continuous support and updates to keep your systems ahead of the curve.',
    },
];

export default process;